import { isString, zip, constant, has, first, get, isArray, isEmpty } from 'lodash'
import { BASE_URL } from 'config'
import { extraKeys } from './DocumentMapper/constants'

const { DETAIL_ID_KEY } = extraKeys

// Field properties that will be available inside AG Grid custom cell renderers
const cellParamsKey = [
  'documentType',
  'filterField',
  'filterKey',
  'filter',
  'optionsKey',
  'valueKey',
  'labelKey',
  'options',
  'findBy',
  'operation',
  'operands',
  'excludeCurrentDocument',
  'src'
]

const statesToReset = ['disabled', 'hidden']

const getUndefined = constant(undefined)

export const HEADER_FIELD_SYMBOL = '^'

export const buildRowId = (dataId = {}) => {
  const { id, activityId } = dataId
  return `${id}-${activityId}`
}

// Keep backwards compatibility
export const adapters = {
  getId: (field) => field.id || field.field,
  getFields: (section) => section.fields || section.columnDefs,
  getLabel: (field) => field.labelText || field.headerName,
  getCellParams: (field) =>
    field.cellEditorParams ||
    cellParamsKey.reduce((acc, key) => ({ ...acc, [key]: field[key] }), {})
}

// Extract props from validation states, to pass to components
export const getPropsFromFieldState = (fieldState = []) =>
  fieldState.reduce((acc, { state, validationResult, ...rest }) => {
    return state ? { ...acc, [state]: true, ...rest } : acc
  }, {})

export const nullFieldsByState = (document, fieldStates, sectionMap) => {
  const newDocument = { ...document }

  for (const field in fieldStates) {
    const fieldArray = fieldStates[field]

    if (has(first(fieldArray), 'state')) {
      //first level field
      const [{ state } = {}] = fieldArray
      resetField(state, newDocument, field, sectionMap)
    } else {
      //nested level field
      fieldArray.forEach((rowDetail, index) => {
        //detail rows
        for (const detailField in rowDetail) {
          //row fields
          const [{ state } = {}] = rowDetail[detailField]
          resetField(state, newDocument[field][index], detailField, sectionMap)
        }
      })
    }
  }

  return newDocument
}

const resetField = (state, documentPortion, fieldToReset, sectionMap) => {
  if (statesToReset.includes(state)) {
    if (sectionMap[fieldToReset]) {
      sectionMap[fieldToReset].forEach(
        (detailId) => (documentPortion[detailId] = [])
      )
    }
    documentPortion[fieldToReset] = null
  }
}

export const toArray = (x) => (Array.isArray(x) ? x : [x])

// Process filters to get an array with correct matches, to be then consumed by other code
// Example input:  ['a', 'b', 'c'], [1, 2], 3
// Example output: [['a', 1], ['b', 2], ['c', 3]]
export const processFilters = (filterFields, filterValues1, filterValues2) => {
  const values = toArray(filterValues1 || []).concat(filterValues2 || [])
  const fields = toArray(filterFields)
  if (fields.length !== values.length) throw new Error('Lengths mismatch')
  return zip(fields, values)
}

export const getOptionsRemoteUrl = (instanceId, documentType, query) =>
  `${BASE_URL}/instances/${instanceId}/documents?type=${documentType}${
    query ? `&${query}` : ''
  }`

export const getOptionsCacheKey = (instanceId, documentType, query) =>
  `${documentType}:${instanceId}${query ? `:${query}` : ''}`

/**
 * Returns the path to the input view for the specified
 * document type, in the specified working table and scenario.
 */
export const getInputViewPathForDocumentType = ({ scenarioId, wtId, wtType }) =>
  `/instances/${scenarioId}/workingtables/${wtId}/${wtType}/documents`

const isObject = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

export const resolveFilterKeys = ({
  keys,
  detailId,
  detailField,
  currentDocument
}) => {
  if (!keys) return []

  const keysArray = toArray(keys)

  if (!currentDocument) {
    return keysArray.map(getUndefined) // The output array's length must always match the number of keys
  }

  const document = detailField
    ? (
        currentDocument.staging?.[detailField] || // Check the staging object first, in case it's a server-side detail
        currentDocument[detailField]
      )?.find((row) => row[DETAIL_ID_KEY] === detailId)
    : currentDocument

  return keysArray.map((key) => {
    if (key.startsWith(HEADER_FIELD_SYMBOL)) {
      const val = get(currentDocument, key.replace(HEADER_FIELD_SYMBOL, ''))
      return isObject(val) ? val.uri : val
    }

    const val = get(document || {}, key)
    return isObject(val) ? val.uri : val
  })
}

export const isStringUri = (value) =>
  isString(value) && value.startsWith('ev://')


  export const getAutocompleteLinkLabel=(data,labelKey)=> {
    if(!data) return data
    if(isArray(labelKey) ){
      if(isEmpty(labelKey)) throw new Error(`${data?.type} - Labelkey cannot be empty!`);
  
      const labelKeys= labelKey.filter(key=> data[key]).map(k=>data[k])
  
      return labelKeys.length>1? labelKeys.join(' - '): first(labelKeys)
    } else{
      return data[labelKey]
    }
  }
  